// Create a new file: AssignOrderModal.jsx
import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Input, Label } from "reactstrap";
import { Button } from "../../../Component";

const AssignOrderModal = ({ isOpen, toggle, selectedRow, users, onAssign }) => {
  const [selectedUserId, setSelectedUserId] = React.useState(users.id);

  const handleAssign = () => {
    if (selectedUserId && selectedRow) {
      onAssign(selectedRow, selectedUserId);
      setSelectedUserId(null);
      toggle();
    }
  };
  console.log(users,"users")
  console.log(selectedRow,"selected\r|owww")

  return (
   <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
  <ModalHeader toggle={toggle}>Assign Order #{selectedRow?.orderNum || selectedRow?.order_no}</ModalHeader>
  <ModalBody>
    <p className="mb-3">
      Select a user to assign this order to:
    </p>
    <div className="nk-block">
      {users?.map((user) => (
        <FormGroup check key={user.id} className="mb-2">
          <Label check className="d-flex align-items-center">
            <Input
              type="radio"
              name="userAssignment"
              value={user.id}
              checked={selectedUserId === user.id} 
              onChange={(e) => setSelectedUserId(e.target.value)}
            />
            <div className="ms-2">
              <strong>{user.name}</strong>
              <span className="text-muted ms-2">({user.email || user.role})</span>
                 <span className="text-muted ms-2">({user.mobile || user.role})</span>
            </div>
          </Label>
        </FormGroup>
      ))}
    </div>
  </ModalBody>
  <ModalFooter>
    <Button color="secondary" onClick={toggle}>
      Cancel
    </Button>
    <Button color="primary" onClick={handleAssign} disabled={!selectedUserId}>
      Assign Order
    </Button>
  </ModalFooter>
</Modal>
  );
};

export default AssignOrderModal;